module.exports = __webpack_public_path__ + "img/my-info-icon.05c56929.svg";